module.exports = {
      id: "line-arrow-next-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#line-arrow-next",
      toString: function () {
        return this.url;
      }
    }